import React from 'react';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { useSubjectListQuery } from 'src/modules/exam-preparation/graphql/subject/getList';
import { useRearrangeSubjectsMutation } from 'src/modules/exam-preparation/graphql/subject/rearrange';
import SubjectFormDrawer from './SubjectFormDrawer';
export default function useData(examLevel, type) {
    const [queryState, queryActions] = useSubjectListQuery(examLevel.id, type);
    const [, rearrangeActions] = useRearrangeSubjectsMutation();
    const handleAddSubject = useStableCallback(() => {
        bottomDrawerHelperActions.show({
            component: React.createElement(SubjectFormDrawer, {
                examLevelID: examLevel.id,
                type,
            }),
        });
    });
    const handleEditSubject = useStableCallback((subject) => {
        bottomDrawerHelperActions.show({
            component: React.createElement(SubjectFormDrawer, {
                examLevelID: examLevel.id,
                type,
                subject,
            }),
        });
    });
    const handleRearrangeSubjects = useStableCallback((subjectIDs) => {
        rearrangeActions.submit({
            variables: {
                examLevelID: examLevel.id,
                type,
                subjectIDs,
            },
            optimisticResponse: {
                ep_rearrangeSubjects: true,
            },
        });
    });
    const state = {
        query: queryState,
    };
    const actions = {
        query: queryActions,
        handleAddSubject,
        handleEditSubject,
        handleRearrangeSubjects,
    };
    return [state, actions];
}
